import { useEffect, useState } from "react";
import axios from "axios";
import { Menu, X, ArrowUpRight, Lock, LayoutDashboard } from "lucide-react";
import { scrollToSection } from "@/App";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const LINKS = [
  { label: "Why Us", id: "#why", testid: "nav-link-why" },
  { label: "Products", id: "#products", testid: "nav-link-products" },
  { label: "Capabilities", id: "#capabilities", testid: "nav-link-capabilities" },
  { label: "Contact", id: "#contact", testid: "nav-link-contact" },
];

export const Navbar = () => {
  const [open, setOpen] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);

  useEffect(() => {
    axios
      .get(`${API}/auth/me`, { withCredentials: true })
      .then(() => setIsAdmin(true))
      .catch(() => setIsAdmin(false));
  }, []);

  const go = (id) => {
    setOpen(false);
    scrollToSection(id);
  };

  return (
    <header
      data-testid="main-nav"
      className="fixed top-0 left-0 right-0 z-50 bg-royal border-b border-white/10 shadow-[0_4px_24px_rgba(0,0,0,0.3)]"
    >
      <div className="max-w-[1440px] mx-auto px-5 md:px-10 h-16 md:h-[72px] flex items-center justify-between">
        <button
          data-testid="nav-logo"
          onClick={() => window.__lenis?.scrollTo(0, { duration: 1.4 })}
          className="flex items-center"
        >
          <span className="bg-white px-3 py-1.5">
            <img src="/assets/dv-logo.png" alt="D V Steels — Strong. Reliable. Built to Last." className="h-6 md:h-7 w-auto" />
          </span>
        </button>

        <nav className="hidden md:flex items-center gap-8">
          {LINKS.map((l) => (
            <button
              key={l.id}
              data-testid={l.testid}
              onClick={() => go(l.id)}
              className="font-mono text-xs tracking-[0.2em] uppercase text-white/75 hover:text-white transition-colors duration-300"
            >
              {l.label}
            </button>
          ))}
          <button
            data-testid="nav-quote-button"
            onClick={() => go("#contact")}
            className="btn-sweep btn-solid font-heading font-semibold uppercase tracking-wider text-base px-5 py-2 flex items-center gap-1"
          >
            Get a Quote <ArrowUpRight size={16} />
          </button>
          {isAdmin ? (
            <a
              data-testid="nav-admin-panel-button"
              href="/admin"
              className="btn-sweep btn-ghost font-heading font-semibold uppercase tracking-wider text-base px-5 py-2 flex items-center gap-1.5"
            >
              <LayoutDashboard size={16} /> Admin Panel
            </a>
          ) : (
            <a
              data-testid="nav-admin-login-icon"
              href="/admin"
              aria-label="Admin login"
              className="text-white/50 hover:text-white transition-colors duration-300"
            >
              <Lock size={15} />
            </a>
          )}
        </nav>

        <button
          data-testid="nav-mobile-toggle"
          className="md:hidden text-white p-2"
          onClick={() => setOpen(!open)}
          aria-label="Toggle menu"
        >
          {open ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {open && (
        <div data-testid="nav-mobile-menu" className="md:hidden bg-royal border-t border-white/10 px-5 py-6 flex flex-col gap-5">
          {LINKS.map((l) => (
            <button
              key={l.id}
              data-testid={`${l.testid}-mobile`}
              onClick={() => go(l.id)}
              className="text-left font-heading font-semibold uppercase text-xl text-white"
            >
              {l.label}
            </button>
          ))}
          <button
            data-testid="nav-quote-button-mobile"
            onClick={() => go("#contact")}
            className="btn-sweep btn-solid font-heading font-semibold uppercase tracking-wider text-base px-6 py-3 mt-2 w-fit"
          >
            Get a Quote
          </button>
          {isAdmin ? (
            <a
              data-testid="nav-admin-panel-button-mobile"
              href="/admin"
              className="font-heading font-semibold uppercase text-xl text-white flex items-center gap-2"
            >
              <LayoutDashboard size={18} /> Admin Panel
            </a>
          ) : (
            <a
              data-testid="nav-admin-login-icon-mobile"
              href="/admin"
              aria-label="Admin login"
              className="text-white/50 hover:text-white transition-colors duration-300 flex items-center gap-2 text-sm font-mono uppercase tracking-widest"
            >
              <Lock size={15} /> Admin
            </a>
          )}
        </div>
      )}
    </header>
  );
};
